"use client";
import React, { useState, useEffect } from "react";
import Image from "next/image";
import { X, Star } from "lucide-react";
import { APP_CONFIG } from "@/config/app-config";
import { useTranslations } from "next-intl";

const AppDownloadBar = ({ setIsAppOpen }: any) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const t = useTranslations();

  useEffect(() => {
    if (typeof window !== undefined) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
    // Check if user has previously dismissed the download bar
    const dismissed = localStorage.getItem(APP_CONFIG.downloadBar.dismissKey);
    setIsVisible(true);
    // Don't show on Android devices
    const userAgent = navigator.userAgent || navigator.vendor;
    const isAndroid = /android/i.test(userAgent);

    // if (!dismissed && APP_CONFIG.downloadBar.enabled) {
    //   // Add delay if configured
    //   const timer = setTimeout(() => {
    //     setIsVisible(true);
    //   }, APP_CONFIG.downloadBar.showDelay);

    //   return () => clearTimeout(timer);
    // }
  }, []);

  const handleDismiss = () => {
    setIsAppOpen(false);
    setIsVisible(false);
    setIsDismissed(true);
    // localStorage.setItem(APP_CONFIG.downloadBar.dismissKey, "true");
  };

  const handleDownload = () => {
    // Detect device and redirect to appropriate app store
    const userAgent = navigator.userAgent || navigator.vendor;

    if (/iPad|iPhone|iPod/.test(userAgent)) {
      // iOS App Store link
      window.open(APP_CONFIG.appStore.ios, "_blank");
    } else if (/android/i.test(userAgent)) {
      // Google Play Store link
      window.open(APP_CONFIG.appStore.android, "_blank");
    } else {
      // Default to Google Play Store
      window.open(APP_CONFIG.appStore.android, "_blank");
    }
  };

  if (!isVisible || isDismissed) {
    return null;
  }

  return (
    <div className="relative z-50 bg-[#0b0b0b] border-b border-[#d9ac4f]/20 text-[#D1D3D4] shadow-lg md:hidden w-full overflow-hidden">
      <div className="flex items-center justify-between gap-2 max-w-7xl mx-auto px-2 py-2.5 sm:px-4">
        {/* Main Download Bar */}
        <div className="flex items-center gap-1.5 min-w-0 flex-1">
          {/* Close Button */}
          <button
            onClick={handleDismiss}
            className="text-[#D1D3D4] hover:text-[#D1D3D4] transition-colors p-1 rounded-full hover:glass-effect/10 shrink-0"
          >
            <X className="w-4 h-4" />
          </button>
          <div className="flex items-center gap-2 min-w-0 flex-1">
            {/* App Icon */}
            <div className="w-8 h-8 sm:w-10 sm:h-10 glass-effect rounded-full flex items-center justify-center shadow-md shrink-0">
              <Image
                src={APP_CONFIG.app.icon}
                alt={APP_CONFIG.app.name}
                width={20}
                height={20}
                className="rounded-full"
              />
            </div>

            {/* Text and Rating */}
            <div className="flex flex-col min-w-0 flex-1">
              <span className="text-[11px] sm:text-xs font-medium leading-tight truncate">
                {t("appDownload.betterExperience")}
              </span>
              <div className="flex items-center gap-0.5 mt-0.5">
                {[1, 2, 3, 4, 5].map((star) => (
                  <Star
                    key={star}
                    className={`w-2.5 h-2.5 sm:w-3 sm:h-3 ${
                      star <= APP_CONFIG.app.rating
                        ? "fill-yellow-400 text-[#d9ac4f]"
                        : "text-[#D1D3D4]"
                    }`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Download Button */}
        <div className="shrink-0">
          <button
            onClick={handleDownload}
            className="glass-effect text-[#D1D3D4] text-[11px] sm:text-xs py-1.5 px-2.5 rounded-lg font-semibold hover:bg-[#111111] transition-colors flex items-center justify-center gap-1 shadow-md whitespace-nowrap"
          >
            <span>{t("appDownload.downloadApp")}</span>
            <svg
              className="w-3.5 h-3.5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AppDownloadBar;
